import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import CardActionArea from '@material-ui/core/CardActionArea';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import InlineSection from '../../InlineSection/InlineSection';
import { invoiceStatuses } from '../../../constants/statuses';
import intlEquipped, { propTypes as i18nPropTypes } from '../../../hocs/intlEquipped';
import { invoiceStatusKeys } from '../../../constants/invoiceStatusKeys';

const Details = ({ invoice, theme, i18n }) => {
    const { total, status } = invoice;
    const { formatPrice, formatMessage } = i18n;
    const showToBeCharged = status === invoiceStatuses.TO_BE_CHARGED && total.amount > 0;
    const showPaymentStatus = ![invoiceStatuses.PAID, invoiceStatuses.FAILED].includes(status) || showToBeCharged;

    return (
        <>
            <div className={ theme.info }>
                <span className={ theme.price }>{ formatPrice(total) }</span>
                { status && showPaymentStatus && (
                    <span className={ theme.status }>{ formatMessage(invoiceStatusKeys[status]) }</span>
                ) }
            </div>
            <ChevronRightIcon className={ theme.icon } />
        </>
    );
};

const InvoiceItem = ({ invoice, onClick, theme, i18n, isLastOnList }) => {
    const { productName, invoiceDate, status, invoiceNumber } = invoice;
    const { formatDate } = i18n;

    return (
        <Card elevation={ 0 }>
            <CardActionArea className={ theme.invoice } onClick={ () => onClick(invoiceNumber) }>
                <InlineSection
                    theme={ theme }
                    mainContent={ (
                        <>
                            <div className={ theme.name }>{ productName }</div>
                            <div className={ theme.date }>{ formatDate(invoiceDate) }</div>
                        </>
                    ) }
                    subContent={
                        <Details { ...{ invoice, theme, i18n } } />
                    }
                    className={ theme[status && status.toLowerCase()] }
                />
            </CardActionArea>
            { !isLastOnList && <Divider /> }
        </Card>
    );
};

Details.propTypes = {
    invoice: PropTypes.shape({
        productName: PropTypes.string.isRequired,
        invoiceDate: PropTypes.string.isRequired,
        status: PropTypes.string,
        invoiceNumber: PropTypes.string.isRequired,
        total: PropTypes.shape({
            currency: PropTypes.string.isRequired,
            amount: PropTypes.number.isRequired,
        }).isRequired,
    }).isRequired,
    theme: PropTypes.shape({}),
    i18n: i18nPropTypes,
};

InvoiceItem.propTypes = {
    invoice: PropTypes.shape({
        productName: PropTypes.string.isRequired,
        invoiceDate: PropTypes.string.isRequired,
        status: PropTypes.string,
        invoiceNumber: PropTypes.string.isRequired,
        total: PropTypes.shape({
            currency: PropTypes.string.isRequired,
            amount: PropTypes.number.isRequired,
        }).isRequired,
    }).isRequired,
    onClick: PropTypes.func.isRequired,
    isLastOnList: PropTypes.bool.isRequired,
    className: PropTypes.string,
    theme: PropTypes.shape({}),
    i18n: i18nPropTypes,
};

export default intlEquipped(InvoiceItem);
